/** Shown when /{merchant-code} does not match any merchant — never falls back to another tenant. */
export default function MerchantNotFound({ code }) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6"
      data-testid="merchant-not-found">
      <div className="max-w-lg space-y-5 border border-border bg-card p-8">
        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground">
          404 · merchant not found
        </div>
        <h1 className="text-3xl font-semibold tracking-tight">Merchant Not Found</h1>
        <p className="text-sm text-muted-foreground">
          {code ? <span className="font-mono text-foreground">/{code}</span> : "This address"} does not
          match any merchant on this platform.
        </p>
        <p className="text-xs text-muted-foreground">
          Check the merchant code in the link, or ask your platform administrator for the correct
          direct URL.
        </p>
      </div>
    </div>
  );
}
